e360.filter('importerHeaderFilter', [
   function() {
      return function(items, headers) {
         var filtered = [];

         _.each(items, function(item, k) {
            var exists = _.find(headers, function(header) {
               return header.selected == k;
            });

            if (!exists) {
               filtered.push({ key: k, value: item });
            }
         });

         var obj = {};
         _.each(_.sortBy(filtered, 'value'), function(e) {
            obj[e.key] = e.value;
         });

         return obj;
      };
   }
]);
